module.exports = __webpack_public_path__ + "1827cfb2abee6c476f2e3bf99592fdb4.png";